import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 bg-amber-900/10 px-4 sm:px-6 lg:px-8 border-y border-amber-500/10" data-id="element-228">
      <div className="max-w-4xl mx-auto" data-id="element-229">
        <FadeIn data-id="element-230">
          <div className="relative bg-stone-900/50 backdrop-blur-sm border border-amber-500/20 rounded-3xl p-8 md:p-12 text-center" data-id="element-231">
            <Quote className="w-12 h-12 text-amber-500/40 absolute top-6 left-6" data-id="element-232" />
            <Quote className="w-12 h-12 text-amber-500/40 absolute bottom-6 right-6 rotate-180" data-id="element-233" />

            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 relative z-10" data-id="element-234">
              Lo que cambia en 7 días
            </h3>

            <p className="text-lg md:text-xl text-stone-300 leading-relaxed relative z-10" data-id="element-235">
              La primera noche notarás que la presión en el pecho disminuye.
              Para la séptima noche, tu cerebro habrá aprendido que no necesita
              gritarte en la oscuridad porque confía en tu sistema de archivo.{' '}
              <strong className="text-amber-400 font-semibold" data-id="element-236">
                El sueño dejará de ser algo que "intentas" lograr y se
                convertirá en algo que sucede naturalmente.
              </strong>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}